var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.2559,
    y1: 381.5908,
    x2: 366.9513,
    y2: 120.0473
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E4E9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E83484"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M238.649,400.574c-3.085-0.728-8.139-1.269-15.145-1.622c-7.014-0.347-11.153-0.588-12.427-0.729 l1.288-7.531c6.65-38.535,12.069-66.699,16.266-84.46c0.085-0.369,0.161-0.739,0.231-1.103L396.74,201.359L289.217,27.408 L115.26,134.936l102.807,166.318c-3.725,16.029-7.929,37.296-12.623,63.844c-3.23,17.819-5.309,28.67-6.211,32.534l-19.192-1.591 c-8.088-0.281-13.37-0.716-15.845-1.297c-3.704-0.88-6.524-2.027-8.473-3.471c-1.396-0.985-2.869-1.655-4.41-2.024 c-1.857-0.433-3.539,0.471-5.05,2.735c-1.508,2.246-2.522,4.445-3.032,6.613c-0.654,2.778,0.562,4.538,3.648,5.271 c3.56,0.839,11.087,1.4,22.603,1.661c1.926,0.133,5.919,0.299,11.989,0.509c6.066,0.211,11.453,0.702,16.159,1.488 c-4.628,19.611-11.023,36.173-19.179,49.651c-8.156,13.486-17.636,18.954-28.454,16.401c-4.013-0.941-7.329-3.651-9.952-8.1 c-2.62-4.444-4.153-9.497-4.616-15.156c-0.058-1.81-0.245-3.28-0.549-4.406c-0.304-1.137-0.996-1.82-2.08-2.077 c-1.076-0.257-2.399,1.016-3.96,3.825c-1.559,2.819-2.56,5.149-2.997,7.002c-0.693,2.932-0.184,6.48,1.525,10.638 c1.712,4.149,4.4,7.972,8.064,11.438c3.67,3.473,7.963,5.8,12.915,6.96c13.591,3.214,25.692-2.288,36.297-16.499 c10.614-14.226,18.908-33.99,24.887-59.323c3.234,0.119,7.773,0.575,13.612,1.39c5.848,0.802,10.795,1.604,14.847,2.396 c2.818,0.502,4.682-1.18,5.589-5.041c0.366-1.544,0.061-2.836-0.915-3.884C241.689,401.696,240.355,400.975,238.649,400.574z  M286.887,37.283l99.975,161.747l-139.836-5.98l-121.891-55.786L286.887,37.283z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.191af4726bc8e23f9142b8b2cff593f5.svg";
export { ForwardRef as ReactComponent };